// Main entry point for Tamil Soundboard Vue App
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createHead } from '@vueuse/head';

import App from './App.vue';
import router from './router';
import './style.css';

// Create Vue app
const app = createApp(App);

// Setup Pinia with persistence
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

// Setup Head for SEO
const head = createHead();

// Use plugins
app.use(pinia);
app.use(router);
app.use(head);

// Mount app
app.mount('#app');

